import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const DropDownWrapper = styled.div(
    () => css`
        /* Patches shrinking flex issue contained within the frozen blueprint repo. */
        svg[data-testid^='arrow_'] {
            flex: none;
        }
    `
);

export const PropertyTypeWrapper = styled.div(
    () => css`
        display: flex;
        flex-wrap: wrap;
        width: 340px;
    `
);

export const PropertyTypeElement = styled.div(
    () => css`
        padding-bottom: 12px;
        width: 50%;

        &:nth-last-child(2),
        :last-child {
            padding-bottom: 0;
        }
    `
);
